define('responsive-gameday/views/render/MatchupViewRender',['require','exports','module','./ViewRender','Wax/get!view-templates/matchup/matchup','Wax/get!view-templates/teamMatchup/status','Wax/get!view-templates/matchup/batter','Wax/get!view-templates/matchup/pitcher'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        Superclass;

    function MatchupViewRender(showTeamMatchup){
        showTeamMatchup = showTeamMatchup!==false;
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/matchup/matchup'),{
                teamMatchupStatusView   : showTeamMatchup ? require( 'Wax/get!view-templates/teamMatchup/status' ) : '',
                matchupBatterView              : require( 'Wax/get!view-templates/matchup/batter'),
                matchupPitcherView             : require( 'Wax/get!view-templates/matchup/pitcher')
            }
        );
    }
    ViewRender.spawn(MatchupViewRender);

    Superclass=MatchupViewRender.superclass;

    return MatchupViewRender;
});
